<footer class="site-footer">
  <div class="site-footer__inner">
    <div class="site-footer__brand">
      <a class="site-footer__brand-link" routerLink="/" aria-label="United Team Building home">
        United Team Building, LLC
      </a>
      <p class="site-footer__tagline">
        scheduling@unitedteambuilding.com
      </p>
      <p class="site-footer__tagline">
        Team experiences, onboarding support, and customer engagement.
      </p>
    </div>

    <nav class="site-footer__nav" aria-label="Footer navigation">
      @for (item of footerLinks; track item.path) {
      <a class="site-footer__link"
         [routerLink]="item.path">
        {{ item.label }}
      </a>
      }
    </nav>

    <div class="site-footer__meta">
      <p class="site-footer__copy">© {{ year }} United Team Building. All rights reserved.</p>
    </div>
  </div>
</footer>
